import { CustomAxiosRequestConfig, http } from '../../http';
import {
    RequestDeleteDashboardLink,
    RequestGetSharedDashboardLink,
    RequestGetSharedDashboardLinks,
    RequestPostShareDashboardLink,
    RequestPutSharedDashboardLink,
    RequestPutShareDashboardToRoles,
    RequestPutShareDashboardToUsers,
    ResponseDeleteDashboardLink,
    ResponseGetSharedDashboardLink,
    ResponseGetSharedDashboardLinks,
    ResponseGetSharedDashboardToRoles,
    ResponseGetSharedDashboardToUsers,
    ResponsePostShareDashboardLink,
    ResponsePutSharedDashboardLink,
} from './types';

import { __ } from '@/js/stores/expressions';

export const postShareDashboardLink = async (req: RequestPostShareDashboardLink) => {
    const config: CustomAxiosRequestConfig = {
        successMessage: __('create-share-dashboard-link-success'),
        errorMessage: {
            404: __('create-share-dashboard-link-error-response-404', {
                dashboardId: req.dashboardId,
            }),
        },
    };

    const data = await http.post<RequestPostShareDashboardLink, ResponsePostShareDashboardLink>(
        `/dashboard/${req.dashboardId}/sharing/share-link`,
        {
            expirationDate: req.expirationDate,
            password: req.password || null,
        },
        config
    );
    return data;
};

export const getSharedDashboardLinks = async (req: RequestGetSharedDashboardLinks) => {
    const data = await http.get<void, ResponseGetSharedDashboardLinks>(
        `/dashboard/${req.dashboardId}/sharing/links`
    );
    return data;
};

export const deleteSharedDashboardLink = async (req: RequestDeleteDashboardLink) => {
    const config: CustomAxiosRequestConfig = {
        successMessage: __('delete-share-dashboard-link-success'),
        errorMessage: {
            404: __('delete-share-dashboard-link-error-response-404', {
                id: req.id,
            }),
        },
    };

    const data = await http.delete<void, ResponseDeleteDashboardLink>(
        `/dashboard/${req.dashboardId}/sharing/links/${req.id}`,
        config
    );
    return data;
};

export const putSharedDashboardLink = async (req: RequestPutSharedDashboardLink) => {
    const config: CustomAxiosRequestConfig = {
        successMessage: __('update-share-dashboard-link-success'),
        errorMessage: {
            404: __('update-share-dashboard-link-error-response-404', {
                id: req.id,
            }),
        },
    };

    const data = await http.put<void, ResponsePutSharedDashboardLink>(
        `/dashboard/${req.dashboardId}/sharing/links/${req.id}`,
        {
            expirationDate: req.expirationDate,
            password: req.password,
        },
        config
    );
    return data;
};

export const getSharedDashboardLink = async (req: RequestGetSharedDashboardLink) => {
    const data = await http.get<void, ResponseGetSharedDashboardLink>(
        `dashboard/${req.dashboardId}/sharing/links/${req.id}`
    );
    return data;
};

export const getUserSharesForDashboard = async (dashboardId: string) => {
    const response = await http.get<void, ResponseGetSharedDashboardToUsers>(
        `dashboard/${dashboardId}/sharing/users`
    );

    return response.data.users;
};

export const putShareDashboardToUsers = async (req: RequestPutShareDashboardToUsers) => {
    const data = await http.put<void, ResponseGetSharedDashboardToUsers>(
        `/dashboard/${req.dashboardId}/sharing/users`,
        {
            users: req.users,
        }
    );

    return data;
};

export const getRoleSharesForDashboard = async (dashboardId: string) => {
    const response = await http.get<void, ResponseGetSharedDashboardToRoles>(
        `dashboard/${dashboardId}/sharing/roles`
    );

    return response.data.roles;
};

export const putShareDashboardToRoles = async (req: RequestPutShareDashboardToRoles) => {
    const data = await http.put<void, ResponseGetSharedDashboardToRoles>(
        `/dashboard/${req.dashboardId}/sharing/roles`,
        {
            roleIds: req.roleIds,
        }
    );

    return data;
};
